import get from 'lodash/get';
import React, {Component} from 'react';
import {FastField, ErrorMessage} from 'formik';
import {FormattedMessage} from 'react-intl';
import classNames from 'classnames';
import messages from '../../../../res/translations/messages';
import {generateNextChoiceId} from '../../../services/idHelpers';
import MinusButton from './MinusButton';
import UpButton from './UpButton';
import DownButton from './DownButton';
import TooltipIcon from '../../TooltipIcon';
import Error from '../../Error';
import DraggableCell from './DraggableCell';
import DraggableRow from './DraggableRow';
import DragDropTableBody from './DragDropTableBody';
import MediaGalleryModal from '../../media/MediaGalleryModal';

class ExclusiveImageChoiceType extends Component {
    constructor(props) {
        super(props);
        this.state = {shuffled: false, modalOpen: false};

        this.toggleModal = this.toggleModal.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.toggleShuffle = this.toggleShuffle.bind(this);
    }

    toggleModal() {
        this.setState((s) => ({modalOpen: !s.modalOpen}));
    }

    handleSelect({assetId, url}) {
        const choices = get(this.props.form.values, this.props.name);
        this.props.push({id: generateNextChoiceId(choices), value: '', url, assetId, shuffle: false, exclusive: false});
    }

    toggleShuffle(e) {
        const {replace, form, name} = this.props;
        const value = e.target.checked;
        const fields = get(form.values, name);
        this.setState({shuffled: value});

        if (value) {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {shuffle: true}));
            });
        } else {
            fields.forEach((field, index) => {
                replace(index, Object.assign({}, field, {shuffle: false}));
            });
        }
    }

    render() {
        const {remove, move, form, name} = this.props;

        return (
            <table className="table table-sm table-borderless">
                <colgroup>
                    <col style={{width: 120}} />
                    <col />
                    <col style={{width: 150}} />
                    <col style={{width: 80}} />
                    <col style={{width: 50}} />
                    <col style={{width: 80}} />
                    <col style={{width: 50}} />
                    <col style={{width: 80}} />
                </colgroup>
                <thead>
                    <tr>
                        <th className="pl-0"><FormattedMessage {...messages.surveys.form.label.choiceId} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.choiceLabel} /></th>
                        <th><FormattedMessage {...messages.surveys.form.label.image} /></th>
                        <th colSpan="2">
                            <div className="custom-control custom-checkbox">
                                <input className="custom-control-input" type="checkbox"
                                    checked={this.state.shuffled} onChange={this.toggleShuffle} id={`${name}.shuffled`} />
                                <label className="custom-control-label" htmlFor={`${name}.shuffled`}>
                                    <FormattedMessage {...messages.surveys.form.label.shuffled} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.shuffled} />
                                </label>
                            </div>
                        </th>
                        <th colSpan="2">
                            <div className="custom-control-exclusive">
                                <label>
                                    <FormattedMessage {...messages.surveys.form.label.exclusive} />
                                    {' '}
                                    <TooltipIcon message={messages.surveys.form.tooltip.exclusive} />
                                </label>
                            </div>
                        </th>
                        <th />
                    </tr>
                </thead>
                <DragDropTableBody move={move}>
                    {get(form.values, name) && get(form.values, name).map((item, index, arr) => (
                        <DraggableRow item={item} index={index} key={index}>
                            <DraggableCell className="pl-0">
                                <FastField id={`${name}.${index}.id`} name={`${name}.${index}.id`} className={classNames('form-control',
                                    {error: get(form.errors, `${name}.${index}.id`) && get(form.touched, `${name}.${index}.id`)})} />
                                <ErrorMessage name={`${name}.${index}.id`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <FastField id={`${name}.${index}.value`} name={`${name}.${index}.value`} type="text"
                                    className={classNames('form-control',
                                        {error: get(form.errors, `${name}.${index}.value`) && get(form.touched, `${name}.${index}.value`)})} />
                                <ErrorMessage name={`${name}.${index}.value`}>
                                    {(message) => <Error reason={message.key} reasonParams={message.params} />}
                                </ErrorMessage>
                            </DraggableCell>
                            <DraggableCell>
                                <img src={get(form.values, `${name}.${index}.url`)} className="img-fluid" />
                            </DraggableCell>
                            <DraggableCell style={{paddingLeft: '11px'}}>
                                <FastField name={`${name}.${index}.shuffle`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.shuffle`} className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.shuffle`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell>
                            <DraggableCell />
                            <DraggableCell style={{paddingLeft: '11px'}}>
                                <FastField name={`${name}.${index}.exclusive`}>
                                    {({field}) => (
                                        <div className="custom-control custom-checkbox">
                                            <input type="checkbox" name={field.name} id={`${name}.${index}.exclusive`} className="custom-control-input"
                                                checked={field.value} onChange={field.onChange} />
                                            <label className="custom-control-label" htmlFor={`${name}.${index}.exclusive`}>&nbsp;</label>
                                        </div>
                                    )}
                                </FastField>
                            </DraggableCell>
                            <DraggableCell />
                            <DraggableCell className="text-right">
                                {index > 0 && <UpButton move={move} index={index} />}
                                {index + 1 < arr.length && <DownButton move={move} index={index} />}
                                <MinusButton remove={remove} index={index} />
                            </DraggableCell>
                        </DraggableRow>
                    ))}
                </DragDropTableBody>
                <tfoot>
                    <tr>
                        <td colSpan="4" className="pl-0">
                            <button type="button" className="btn btn-outline-primary btn-sm" onClick={this.toggleModal}>
                                <FormattedMessage {...messages.media.button.chooseFromLibrary} />
                            </button>
                        </td>
                    </tr>
                </tfoot>
                <MediaGalleryModal isOpen={this.state.modalOpen} toggle={this.toggleModal} onSelect={this.handleSelect} />
            </table>
        );
    }
}

export default ExclusiveImageChoiceType;
